import { SyntheticEvent, useState } from 'react';

import { useRecoilValue } from 'recoil';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

import { updateReviewers } from 'src/api/projects';
import MultiDropdownMenu from 'src/components/Input/MultiDropDownMenu';
import useAlertSnackbar from 'src/hooks/useAlertSnackbar';
import { userState } from 'src/states/user';
import { Modality } from 'src/types/api/data/image';
import { SelectOption } from 'src/types/client/ui';

import CommonDialog, { CommonDialogProps } from './CommonDialog';

const DropdownContent = styled('div')`
  margin: 16px 0;
`;

interface Props extends CommonDialogProps {
  projectId: string;
  modality: Modality;
  onUpdate: () => void;
}

export default function AddReviewerDialog({
  open,
  onClose,
  onUpdate,
  projectId,
  modality,
}: Props): JSX.Element {
  const { openAlertSnackbar } = useAlertSnackbar();
  const options = useRecoilValue(userState.userOptionList(modality));
  const [selectedCandidates, setSelectedCandidates] = useState<SelectOption[]>(
    []
  );

  const handleSelectAnnotator = (
    event: SyntheticEvent,
    value: SelectOption[] | null
  ) => {
    setSelectedCandidates(value || []);
  };

  const handleClickAddReviewers = async () => {
    try {
      await updateReviewers(
        projectId,
        modality,
        selectedCandidates.map(user => ({ id: user.value, associates: [] }))
      );
      openAlertSnackbar({
        severity: 'success',
        description: 'Successfully added new reviewers',
      });
    } catch {
      openAlertSnackbar({
        severity: 'error',
        description: 'Failed to add new reviewers',
      });
    }
    onUpdate();
  };

  return (
    <CommonDialog
      onClose={onClose}
      title="Add New Reviewers"
      open={open}
      fullWidth
    >
      <DialogContent>
        <DropdownContent>
          <MultiDropdownMenu
            label="Select users"
            options={options}
            onChange={handleSelectAnnotator}
          />
        </DropdownContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleClickAddReviewers}
          disabled={options.length === 0 || selectedCandidates.length === 0}
        >
          Add
        </Button>
      </DialogActions>
    </CommonDialog>
  );
}
